import { render, staticRenderFns } from "./AccountInfoItem.vue?vue&type=template&id=6a8efa70&scoped=true&"
import script from "./AccountInfoItem.vue?vue&type=script&lang=js&"
export * from "./AccountInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./AccountInfoItem.vue?vue&type=style&index=0&id=6a8efa70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8efa70",
  null
  
)

export default component.exports